import React, { useState, useContext, useEffect } from 'react';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

import Modal from 'react-bootstrap/Modal';

import { Link } from 'react-router-dom';

import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css"

import arrowLeftBlue from "../../../../assets/img/DashboardICons/ArrowLeftBlue.svg"

const ShowProfileModal = (props) => {
    const { consultantData, permissions } = useContext(UserContext);
    const [consultantsDetail, setConsultantsDetail] = useState({
        fullName: "",
        birthDate: "",
        education: "",
        jobPosition: "",
        joinDate: "",
        phoneNumber: "",
        personalCode: ""
    })

    useEffect(() => {
        if (consultantData) {
            setConsultantsDetail((prev) => {
                return {
                    ...prev, fullName: consultantData?.fullName?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]), birthDate: consultantData?.birthDate?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
                    education: consultantData?.education?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
                    phoneNumber: consultantData?.phoneNumber?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
                    joinDate: consultantData?.registerDate?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
                    personalCode: consultantData?.personnelCode?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
                    jobPosition: permissions?.find(item => item === 16) ? "مشاور" : permissions?.find(item => item === 18) ? "سرپرست" : permissions?.find(item => item === 15) && "سوپر یوزر"
                };
            });
            // setConsultantsDetail({
            //     ...consultantsDetail,
            //     fullName: consultantData?.fullName?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     birthDate: consultantData?.birthDate?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     education: consultantData?.education?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     phoneNumber: consultantData?.phoneNumber?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     joinDate: consultantData?.registerDate?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     personalCode: consultantData?.personnelCode?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]),
            //     jobPosition: permissions?.find(item => item === 16) ? "مشاور" : permissions?.find(item => item === 18) ? "سرپرست" : permissions?.find(item => item === 15) && "سوپر یوزر"
            // });
        }
    }, [consultantData, permissions])

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            جزئيات مشاور
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100 d-flex align-items-center justify-content-center flex-column mt-2 mb-3">
                        <img loading='lazy' className={ModalStyles.profile_img} src={`https://backdev.azrmelk.com/images/users/avatar/${ + consultantData?.imageUrl?.replace("images/users/avatar/", "") || "avatar.png"}`} alt="user-profile" />
                        <div className="d-flex align-items-center justify-content-center mt-3">
                            <div className={`me-2 ${ModalStyles.text_black_sm}`}>
                                {consultantsDetail.personalCode}
                            </div>
                            <div className={ModalStyles.text_gray}>
                                : کد پرسنلی
                            </div>
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap">
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                تاریخ تولد
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="birthDate" value={consultantsDetail.birthDate} />
                        </div>
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                نام و نام خانوادگی
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="fullName" value={consultantsDetail.fullName} />
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap">
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                تحصیلات
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="education" value={consultantsDetail.education} />
                        </div>
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                سمت
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="jobPosition" value={consultantsDetail.jobPosition} />
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap">
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                شماره تماس
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="phoneNumber" value={consultantsDetail.phoneNumber} />
                        </div>
                        <div className='d-flex align-items-end justify-content-center flex-column my-2'>
                            <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>
                                تاریخ عضویت
                            </div>
                            <input className={ModalStyles.modal_input} type="text" name="joinDate" value={consultantsDetail.joinDate} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button onClick={props.onHide}>Close</Button> */}
                    <div className="w-100 d-flex align-items-center justify-content-start ms-4">
                        {props.onMyAccount ?
                            <div onClick={() => props.onHide()} className={`pointer ${ModalStyles.text_blue}`}>
                                <img className='me-2' src={arrowLeftBlue} alt="icon" />
                                جزئيات بیشتر
                            </div>
                            :
                            <Link to={props.onMyAccount === "#" ? "#" : "/my-account"} className={ModalStyles.text_blue}>
                                <img className='me-2' src={arrowLeftBlue} alt="icon" />
                                جزئيات بیشتر
                            </Link>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ShowProfileModal;